import React from 'react'
import classes from './styles.module.scss'

export default class WhiteSpace extends React.Component {
  // constructor (props) {
  //   super(props)
  //   this.state = {
  //     foo: 'foo'
  //   }
  // }
  render() {
    const { size = 'lg' } = this.props
    return <div className={classes.componentsWhiteSpace} data-size={size} />
  }
}
